import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, isDemoMode } from "../firebase";
import { DEMO_USER } from "../demoData";

export function useAuth() {
  const [user, setUser] = useState(isDemoMode ? DEMO_USER : undefined);
  const [loading, setLoading] = useState(!isDemoMode);

  useEffect(() => {
    if (isDemoMode) return;
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return { user, loading };
}
